import { FileType } from 'shared-utils/file-system';

export const DPU_FILE_TYPES = ['setup', 'data'] as const;

export type DpuFileType = typeof DPU_FILE_TYPES[number];

export const isDpuFileType = (fileType: FileType): fileType is DpuFileType => DPU_FILE_TYPES.some(dpuFileType => dpuFileType === fileType);
